import axios from "../../axios";

// CATEGORY 12
const api = {
  getTreatmentOfSoldProductsItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/organization-questionnaires/${params.questionnaireId}/treatment-of-sold-products/items`,
      config).then(({ data }) => data);
  },

  addTreatmentOfSoldProductsItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/organization-questionnaires/${questionnaireId}/treatment-of-sold-products/items`, data, headers)
      .then(({ data }) => data);
  },

  updateTreatmentOfSoldProductsItem({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/organization-questionnaires/${questionnaireId}/treatment-of-sold-products/items/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deleteTreatmentOfSoldProductsItem({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/organization-questionnaires/${questionnaireId}/treatment-of-sold-products/items/${recordId}`, headers)
      .then(({ data }) => data);
  },

  importTreatmentOfSoldProductsItems({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/organization-questionnaires/${questionnaireId}/treatment-of-sold-products/items/import`, data, headers).then(({ data }) => data);
  },

  getTemplate(accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `/organization-questionnaires/treatment-of-sold-products/items/template`, config
    ).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = headers["content-disposition"]?.split("filename=")?.[1] ??
        "Scope3_Category12_template";
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  }
};

export default api;
